module.exports = __webpack_public_path__ + "img/nucleus.7067347a.svg";